import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../apiCall';
import { customHeaders, indianProjectsBaseURL } from './../../../../Containers/Config/index';

import { PRICE_PREVIEW, PRICE_PREVIEW_SUCCESS, PRICE_PREVIEW_ERROR } from './../../actionType';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* pricePreview({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-price-preview`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      yield put({ type: PRICE_PREVIEW_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: PRICE_PREVIEW_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: PRICE_PREVIEW_ERROR, payload: error });
  }
}

export function* watchPricePreview() {
  yield takeEvery(PRICE_PREVIEW, pricePreview);
}

function* pricePreviewSaga() {
  yield all([fork(watchPricePreview)]);
}

export default pricePreviewSaga;
